import { render, staticRenderFns } from "./AvailabilitySlots.vue?vue&type=template&id=117f2996&scoped=true&"
import script from "./AvailabilitySlots.vue?vue&type=script&lang=js&"
export * from "./AvailabilitySlots.vue?vue&type=script&lang=js&"
import style0 from "./AvailabilitySlots.vue?vue&type=style&index=0&id=117f2996&prod&lang=scss&"
import style1 from "./AvailabilitySlots.vue?vue&type=style&index=1&id=117f2996&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f2996",
  null
  
)

export default component.exports